/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Scroll_RightInputs */

const en_ui_scroll_right = /** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll right`)
};

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const ar_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const he_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const ur_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const es_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const fr_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const de_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const pt_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const hi_ui_scroll_right = en_ui_scroll_right;

/** @type {(inputs: Ui_Scroll_RightInputs) => LocalizedString} */
const bn_ui_scroll_right = en_ui_scroll_right;

/**
* | output |
* | --- |
* | "Scroll right" |
*
* @param {Ui_Scroll_RightInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_scroll_right = /** @type {((inputs?: Ui_Scroll_RightInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Scroll_RightInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_scroll_right(inputs)
	if (locale === "he") return he_ui_scroll_right(inputs)
	if (locale === "ur") return ur_ui_scroll_right(inputs)
	if (locale === "es") return es_ui_scroll_right(inputs)
	if (locale === "fr") return fr_ui_scroll_right(inputs)
	if (locale === "de") return de_ui_scroll_right(inputs)
	if (locale === "pt") return pt_ui_scroll_right(inputs)
	if (locale === "hi") return hi_ui_scroll_right(inputs)
	if (locale === "bn") return bn_ui_scroll_right(inputs)
	return /** @type {LocalizedString} */ ("Scroll right")
});